import { render, staticRenderFns } from "./import.vue?vue&type=template&id=57bade60&scoped=true&"
import script from "./import.vue?vue&type=script&lang=js&"
export * from "./import.vue?vue&type=script&lang=js&"
import style0 from "./import.vue?vue&type=style&index=0&id=57bade60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bade60",
  null
  
)

export default component.exports